<template>
  <footer class="clear-fix">
    <div class="footer-section" :class="[{ index: from == 'index' }]">
      <div class="footer-top">
        <div class="left">
          <div class="flex">
            <div class="info-item">
              <div class="icon-wrapper"><i class="el-icon-phone"></i></div>
              <div class="info">
                <p class="label">服务热线</p>
                <p class="val">028-81135027</p>
              </div>
            </div>
            <div class="info-item">
              <div class="icon-wrapper"><i class="el-icon-message"></i></div>
              <div class="info">
                <p class="label">电子邮件</p>
                <p class="val">blockchain@cee.net.cn</p>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="icon-wrapper"><i class="el-icon-location"></i></div>
            <div class="info">
              <p class="label">地址</p>
              <p class="val">成都市锦江区三色路38号成都传媒大厦B座</p>
            </div>
          </div>
        </div>
        <div class="right">
          <p class="code-title">扫码关注我们</p>
          <img class="gzh-code" src="../assets/gzh_code.png" />
          <p class="code-desc">微信公众号</p>
        </div>
      </div>
      <div class="footer-bottom">
        <span> Copyright &copy;2022 cdcee.com All Rights Reserved</span>
        <span>
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
          >
            蜀ICP备10025017号-1
          </a>
        </span>
        <span>区块链备案：蜀网信备5101042296955499001X号</span>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "page-footer",
  props: {
    from: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
footer {
  color: #7a8399;
  background: #0d1726;
  font-size: 16px;
}

footer .footer-bottom {
  height: 60px;
  line-height: 58px;
  text-align: center;
  border-top: 1px solid #252e3b;
}
footer .footer-section.index .footer-top {
  display: flex;
}
footer .footer-section span + span {
  margin-left: 20px;
}
footer .footer-section span,
footer .footer-section span a {
  font-size: 12px;
  color: #fff;
}
footer .footer-top {
  margin: 0 auto;
  max-width: 1200px;
  box-sizing: border-box;
  padding: 30px 0;
  display: none;
  align-items: flex-end;
  justify-content: space-between;
  color: #fff;
}
footer .footer-top .flex {
  display: flex;
}
footer .footer-top .info-item {
  display: flex;
  align-items: center;
  margin-top: 25px;
}
footer .footer-top .info-item .icon-wrapper {
  margin-right: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: rgba(41, 48, 61, 0.9);
  border-radius: 50%;
}
footer .footer-top .info-item .icon-wrapper i {
  font-size: 18px;
}
footer .footer-top .info-item .info {
  line-height: 1.6;
}
footer .footer-top .info-item + .info-item {
  margin-left: 44px;
}
footer .footer-top .right {
  width: 96px;
  text-align: center;
}
footer .footer-top .right .code-title {
  margin-bottom: 14px;
}
footer .footer-top .right img {
  margin: 0 auto;
  width: 88px;
  height: 88px;
  background: #fff;
}
footer .footer-top .right .code-desc {
  margin-top: 6px;
  font-size: 14px;
}

@media (max-width: 1199px) {
  footer {
    font-size: 14px;
  }
  footer .footer-top {
    padding: 20px;
  }
}
@media (max-width: 800px) {
  footer {
    font-size: 14px;
  }

  footer .footer-section.index .footer-top {
    display: block;
  }

  footer .footer-top .left-title {
    text-align: center;
  }

  footer .footer-top .right {
    margin: 20px auto;
  }

  footer .footer-bottom {
    height: auto;
    line-height: 1.8;
    padding: 20px 10px;
  }

  footer .footer-bottom span {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page-footer.vue